import React from 'react';
import { useOrganization } from '../../contexts/OrganizationContext';
import './OrganizationHeader.css';

export const OrganizationHeader: React.FC = () => {
  const { organization } = useOrganization();

  if (!organization) {
    return null;
  }

  return (
    <div className="organization-header">
      {organization.logoUrl && (
        <img 
          src={organization.logoUrl} 
          alt={organization.name}
          className="organization-logo"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      )}
      <span className="organization-name">{organization.name}</span>
    </div>
  );
};



